/** SV translations for Les Aiguilles Blanches */
const sv: Record<string, string> = {
  subtitle: "Pistmaskinssimulator",
  startGame: "Starta spel",
  resumeGame: "Fortsätt",
  newGame: "Nytt spel",
  // UNUSED continue: "Fortsätt",
  settings: "Inställningar",
  controls: "Kontroller",
  changelog: "Nyheter",
  howToPlay: "Så spelar du",
  fullscreen: "Helskärm",
  fullscreenHint: "Tryck F för helskärm",
  exitFullscreen: "Avsluta helskärm",
  back: "Tillbaka",
  backToGame: "Tillbaka till spelet",
  // UNUSED loading: "Laddar...",
  inputKeyboard: "✓ Tangentbord upptäckt",
  inputKeyboardOff: "✗ Inget tangentbord",
  inputTouch: "✓ Pekskärm upptäckt",
  inputTouchOff: "✗ Ingen pekskärm upptäckt",
  inputGamepad: "✓ Gamepad ansluten",
  inputGamepadOff: "✗ Ingen gamepad",
  updateAvailable: "Ny version tillgänglig — tryck för att ladda om",
  madeIn: "Gjord med ❄️ i Savoie",
  feedback: "Skicka feedback",
  on: "✓ PÅ",
  off: "✗ AV",
  zoneClosed: "🚫 ZON STÄNGD",

  // Settings
  language: "Språk",
  accessibility: "Tillgänglighet",
  highContrast: "Hög kontrast",
  reducedMotion: "Reducerad rörelse",
  showFps: "Visa FPS",
  showDebug: "Felsökningsinfo",
  skiStyle: "Stil",
  skiTricks: "Trick",
  skiBestCombo: "Bästa kombo",
  quitGame: "Avsluta spelet",
  display: "Visning",
  displayWindowed: "Fönster",
  displayFullscreen: "Helskärm",
  displayBorderless: "Ramlös",
  colorblindMode: "Färgblindhet",
  none: "Ingen",
  deuteranopia: "Deutan.",
  protanopia: "Protan.",
  tritanopia: "Tritan.",
  // UNUSED move: "Flytta",
  moveUp: "Upp",
  moveDown: "Ner",
  moveLeft: "Vänster",
  moveRight: "Höger",
  groom: "Pista",
  winch: "Vinsch",
  pause: "Paus",
  keyboard: "Tangentbord",
  clickToRebind: "Klicka för att ändra",
  pressKey: "Tryck på en tangent...",
  pressGamepadButton: "Tryck på en gamepad-knapp...",
  noGamepad: "Ingen handkontroll ansluten",
  gamepadButtons: "Gamepad",
  saved: "Sparat!",
  resetControls: "Återställ",
  controlsReset: "Kontroller återställda!",
  movementSensitivity: "Känslighet",
  keyboardLayout: "Layout",
  customBindings: "Anpassad",
  // UNUSED gamepadSupported: "Gamepad OK",
  touch: "Pekskärm",
  // UNUSED touchSupported: "Pekskärm OK",
  noGamepadConnected: "Ingen handkontroll ansluten",
  gamepadDiagnostic: "Kontrolltest",
  connectGamepadDiag: "Anslut en kontroll för att testa",
  gamepadDiagButtons: "Knappar",
  gamepadDiagSticks: "Spakar",
  gamepadDiagTriggers: "Avtryckare",

  // Audio
  audio: "Ljud",
  masterVolume: "Huvudvolym",
  musicVolume: "Musik",
  sfxVolume: "Ljudeffekter",
  engineVolume: "Motor",
  voiceVolume: "Röst",
  ambienceVolume: "Atmosfär",
  mute: "Ljud av",

  backgroundAudio: "Bakgrundsljud",
  // Gameplay
  bonus: "Bonus",
  skiMode: "Utförsläge",
  ski: "Skidor",
  snowboard: "Snowboard",
  random: "Slumpmässig",
  skiIt: "Åk skidor!",
  rideIt: "Brädan!",
  skiAgain: "Åk igen!",
  rideAgain: "Åk igen!",
  skiRunSpeed: "Fart",
  skiRunTime: "Tid",
  skiRunGates: "Portar",

  // How to Play hints
  howToPlayMove: "{keys} eller pilar för att köra",
  howToPlayMoveTouch: "Använd den virtuella D-paden",
  howToPlayMoveGamepad: "Vänster spak eller D-pad för att köra",
  howToPlayMoveHybrid: "{keys}/pilar eller pek-D-pad",
  howToPlayGroom: "{groomKey} för att preparera snön",
  howToPlayGroomTouch: "Håll prepareringsknappen",
  howToPlayGroomGamepad: "för att preparera snön",
  howToPlayGroomHybrid: "{groomKey} eller håll prepareringsknappen",
  howToPlayFuel: "Håll koll på bränsle och uthållighet!",
  howToPlayWinch: "{winchKey} nära en förankring för vinsch",
  howToPlayWinchTouch: "Håll vinschknappen nära en förankring",
  howToPlayWinchGamepad: "nära en förankring för vinsch",
  howToPlayWinchHybrid: "{winchKey} eller håll vinschknappen nära en förankring",

  // Winch
  winchSnapped: "💥 Vajern brast!",
  winchAttached: "🔗 Vinsch fäst! Håll {winchKey} för assistans.",
  winchActive: "VINSCH",
  // UNUSED winchHint: "Tryck {winchKey} nära en numrerad förankringsstolpe för vinsch",
  // UNUSED winchHintTouch: "Håll 🔗 för vinsch",
  // UNUSED accessPath: "Serviceväg",
  // UNUSED toPiste: "Till pisten",

  // Taunts - Cliff falls
  tauntCliff1: "9 ton ner i ravinen. Försäkringsbolaget blir glatt.",
  tauntCliff2: "Jean-Pierre sa 'inte för nära kanten!' Minns du?",
  tauntCliff3: "Pistpatrullen tar sig ner med rep. Igen.",
  tauntCliff4: "Marie avbokar din raclette-reservation i kväll.",
  tauntCliff5: "Thierry räknar redan på reparationskostnaden...",

  // Taunts - Fuel empty
  tauntFuel1: "Mätaren stod på rött i 10 minuter. Vad tittade du på?",
  tauntFuel2: "Émilie skrev 'TANKA' med stora bokstäver på tavlan.",
  tauntFuel3: "Även diesel har sina gränser. Du också, tydligen.",
  tauntFuel4: "Jean-Pierre suckar. Han skickar Thierry med en dunk.",
  tauntFuel5: "Solen går upp. Pisten är inte preparerad. Skidåkarna kommer.",

  // Taunts - Time limit
  tauntTime1: "Första stolliften om 3... 2... 1... Missat.",
  tauntTime2: "Skidåkarna upptäcker din pist. Guppig. Isig. Magnifikt.",
  tauntTime3: "Jean-Pierre tittar på klockan, sen på dig, sen klockan.",
  tauntTime4: "FIS undrar varför slalomen ligger i slask.",
  tauntTime5: "Du hör skidlärarna förklara för kunderna varför det 'inte är deras fel'.",

  // UNUSED paused: "Pausat",
  resume: "Fortsätt",
  quitToMenu: "Till menyn",
  levelComplete: "Backe klar!",
  levelFailed: "Backe misslyckad",
  tryAgain: "Försök igen",
  coverage: "Täckning",
  time: "Tid",
  // UNUSED rating: "Betyg",
  nextLevel: "Nästa backe",
  // UNUSED replay: "Spela om",
  // UNUSED pressContinue: "Tryck mellanslag eller peka för att fortsätta",
  pauseTitle: "⏸️ Paus",
  restart: "Starta om",
  skipRun: "Hoppa över åk",
  newRun: "Ny pist",
  quit: "Avsluta",
  menu: "Meny",
  levelSelect: "Välj bana",
  locked: "Stängd",
   completeToUnlock: "Klara {name} för att låsa upp",
  // UNUSED target: "Mål",
  tutorial: "Skidskola",
  timeUsed: "Tid använd",
  excellent: "Utmärkt!",
  good: "Bra jobbat!",
  passed: "Godkänd",
  bonusFuel: "Bränsle använt",
  bonusFlawless: "Första försöket",
  bonusSpeed: "Tid",
  bonusWinch: "Vinsch-användningar",
  bonusExplore: "Vägar utforskade",
  bonusPrecision: "Prepareringskvalitet",
  retry: "Försök igen",
  gameComplete: "Spelet klart!",
  viewCredits: "Visa tack",
  creditsTitle: "Grattis!",
  creditsSubtitle: "Du har bemästrat Les Aiguilles Blanches",
  creditsCreatedBy: "Skapad av",
  creditsDevelopedWith: "Utvecklad med",
  creditsArtDirection: "Konstnärlig ledning",
  creditsRetroInspiration: "En hyllning till retroklassiker som SkiFree",
  creditsInspiredBy: "Inspirerad av",
  creditsGroomers: "Pistmaskinisterna i Savoie",
  creditsDedication: "Till nattskiften som preparerar pisterna medan vi sover",
  creditsThanks: "Tack för att du spelade!",
  creditsSeeYou: "Vi ses på pisterna!",
  creditsLine: "Kom igen, grabben. Solen går upp. Berget är redo.",
  playAgain: "Spela igen",
  skipCredits: "Tryck valfri tangent för att hoppa över",

  // Tutorial
  tutorialName: "Handledning - Första stegen",
  tutorialTask: "Lär dig grunderna i preparering",
  prologueLine: "Klockan 4. Berget är ditt. Dags att jobba.",
  prologueSkip: "Tryck för att fortsätta",
  tutorialIntro: "Välkommen till Les Aiguilles Blanches!",
  skipTutorial: "⏭️ Hoppar över handledning… Tryck för att göra om.",
  skipTutorialGamepad: "⏭️ Hoppar över handledning… Tryck valfri knapp för att göra om.",
  tutorialWelcome: "🏔️ Jean-Pierre, pistchef. Kör på pisten — använd {keys} eller ↑↓←→.",
  tutorialWelcomeTouch: "🏔️ Jean-Pierre, pistchef. Kör på pisten — använd D-paden till vänster.",
  tutorialWelcomeGamepad: "🏔️ Jean-Pierre, pistchef. Kör på pisten — använd vänster spak eller D-pad.",
  // UNUSED     tutorialControls: "🎮 Styr pistmaskinen med {keys} eller piltangenterna ↑↓←→.",
  // UNUSED     tutorialControlsTouch: "🎮 Styr pistmaskinen med D-paden ◀▲▼▶ till vänster.",
  // UNUSED     tutorialControlsGamepad: "🎮 Styr pistmaskinen med vänster spak eller D-pad.",
  // UNUSED     tutorialMove: "➡️ Kör på, testa! Rör dig på pisten — all vit snö behöver prepareras.",
  // UNUSED     tutorialGroomIntro: "✅ Snyggt! Nu lär vi oss preparera.",
  tutorialGroomAction: "❄️ Håll {groomKey} medan du kör för att preparera snön. Den jämnas ut direkt.",
  tutorialGroomActionTouch: "❄️ Håll prepareringsknappen till höger medan du kör för att preparera snön.",
  tutorialGroomActionGamepad: "❄️ Håll {groomKey} medan du kör för att preparera snön. Den jämnas ut direkt.",
  tutorialGroomGoal: "📊 Precis! Preparera minst 60% innan öppning. Skidåkarna kommer!",
  // UNUSED   tutorialCoverage: "📊 Ser du? Snön blir jämnare! Fortsätt preparera pisten.",
  // UNUSED   tutorialHUD: "📈 Kolla instrumentpanelen: röd stapel är bränsle, grön uthållighet, vit täckning. Klockan tickar!",
  // UNUSED   tutorialGoal: "🎯 Du måste preparera minst 60% av pisten innan öppning. Skidåkarna kommer!",
  // UNUSED tutorialFuel: "⛽ Se upp — att köra förbrukar bränsle. Under uppdrag, stanna vid bensinstationen.",
  tutorialComplete: "🏆 Bra gjort! Du kan grunderna. Redo för ditt första riktiga uppdrag på gröna pisten?",

  level_marmottesName: "Grön pist - Les Marmottes",
  level_marmottesTask: "Preparera nybörjarbacken",
  level_chamoisName: "Blå pist - Le Chamois",
  level_chamoisTask: "Preparera effektivt innan öppning",
  level_airZoneName: "Snowpark - Air Zone",
  level_airZoneTask: "Förbered freestyle-moduler",
  level_aigleName: "Röd pist - L'Aigle",
  level_aigleTask: "Preparera brant terräng, hantera bränsle",
  level_glacierName: "Röd pist - Le Glacier",
  level_glacierTask: "Lär dig vinschen på branta sluttningar",
  level_tubeName: "Half-pipe - Le Tube",
  level_tubeTask: "Underhåll half-pipen för tävling",
  level_verticaleName: "Svart pist - La Verticale",
  level_verticaleTask: "Nattoperation med vinsch",
  level_colDangereuxName: "Lavinzon - Col Dangereux",
  level_colDangereuxTask: "Preparera högriskzonen",
  level_tempeteName: "Storm - Återhämtning",
  level_tempeteTask: "Röj pisterna efter stormen",
  level_coupeDesAiguillesName: "Coupe des Aiguilles - FIS-final",
  level_coupeDesAiguillesTask: "Preparera alla pister för tävlingen",

  // Hazards
  cliffFall: "⚠️ VARNING! Du föll ner för klippan! Uppdraget misslyckat.",
  fuelEmpty: "⛽ BRÄNSLET SLUT! Inte en droppe diesel kvar...",
  // UNUSED avalancheZone: "LAVINZON",
  riskLevelHigh: "HÖG",
  avalancheWarning: "⚠️ FARA! Snötäcket är instabilt! Lämna zonen!",
  avalancheTrigger: "🏔️💨 LAVIN UTLÖST! Ingen flykt möjlig!",
  steepWarning: "⚠️ BRANT BACKE! Använd vinschen ({winchKey}) eller du glider!",
  steepWarningNoWinch: "⚠️ BRANT BACKE! Sakta ner och använd servicevägarna för att ta dig runt!",
  tumble: "🔄 VOLTNING! Pistmaskinen välte på sluttningen!",

  // Taunts - Tumble
  tauntTumble1: "Vinschen är inte dekorativ. Den är till för backar som denna.",
  tauntTumble2: "Thierry stirrar på skadorna. Säger inget. Det är värre.",
  tauntTumble3: "Jean-Pierre visade dig hur man förankrar. Sov du?",
  tauntTumble4: "En PistenBully kostar 4 miljoner kronor. Alltså, kostade.",
  tauntTumble5: "Backen verkade hanterbar? Pistmaskinen höll inte med.",
  featureDestroyedKicker: 'Du körde över ett parkelement! Kickern är förstörd.',
  featureDestroyedRail: 'Du körde över ett parkelement! Railen är förstörd.',
  tauntFeature1: 'Det elementet tog tre timmar att bygga. Du plattade till det på tre sekunder.',
  tauntFeature2: 'Émilie kommer att ha ett ord med dig om det parkelementet.',
  tauntFeature3: 'Parkteamet såg dig precis förstöra deras mästerverk.',
  tauntFeature4: 'Element är för skidåkare, inte pistmaskiner. Kör runt!',
  tauntFeature5: 'Ett element mindre till morgondagens tävling.',
  bonusPipeMastery: 'Halfpipe-behärskning',

  // Taunts - Avalanche
  tauntAvalanche1: "Berget förlåter sällan. Det förlät inte.",
  tauntAvalanche2: "Météo France sa risknivå 4. Läste du det?",
  tauntAvalanche3: "Pistpatrullen hittar maskinen till våren. Kanske.",
  tauntAvalanche4: "Marie hör radiovarningen. Hon vet redan att det är du.",
  tauntAvalanche5: "Pistpatrullen hade säkrat sektorn. Du avsäkrade den.",

  // Taunts - Ski wipeout (fun, self-deprecating)
  tauntSkiWipeout1: "Klassisk vurpa. Utrustning överallt, värdighet ingenstans.",
  tauntSkiWipeout2: "Stupet brydde sig inte om din skidteknik.",
  tauntSkiWipeout3: "Pistpatrullen skrattar redan. De såg allt.",
  tauntSkiWipeout4: "Det händer när man åker sin egen pist.",
  tauntSkiWipeout5: "Även stenbockarna grimaserade vid den landningen.",

  // Dialogues
  jeanPierreIntro: "Bra jobbat med handledningen. Nu är det på riktigt — gröna pisten, med tidur och bränsle att hålla koll på.",
  level_marmottesMid: "Ser du det där skenet på topparna? Första ljuset. Det bästa med det här jobbet — bara du, maskinen och berget som vaknar.",
  level_chamoisIntro: "Hej, jag är Émilie — JP skickar dig till blå pisten. Visa att du kan mer än att dra sammet på gröna.",
  level_airZoneIntro: "Snowparken är MITT område — vi bygger nåt sjukt åt dem! Varje modul måste sitta perfekt, åkarna räknar med oss.",
  level_aigleIntro: "L'Aigle är på allvar. Håll koll på bränslet. Servicevägarna leder dig uppåt — leta efter de gula och svarta stolparna.",
  level_glacierIntro: "Hej, jag är Thierry — säkerhetsansvarig. Le Glacier är brant. Jag har kontrollerat varje förankring. Tryck {winchKey} vid en stolpe för att fästa vinschen — och snälla, släpp inte.",
  level_glacierIntroTouch: "Hej, jag är Thierry — säkerhetsansvarig. Le Glacier är brant. Jag har kontrollerat varje förankring. Tryck på vinschknappen vid en stolpe — och snälla, släpp inte.",
  level_tubeIntro: "Imorgon är det contest i Tuben! Rena väggar, vass kant och inga bucklor.",
  level_verticaleIntro: "Nattuppdrag på La Verticale: brant sluttning, farliga kanter. Vinschen är obligatorisk — använd de 3 förankringarna och håll linjen.",
  level_colDangereuxIntro: "Hög lavinrisk på passet — vi kör Lavinsäkerhetsprotokoll aktivt. Håll dig borta från belastade områden och respektera gränserna.",
  level_tempeteIntro: "Stormen har passerat. Ta en vin chaud — det här tar ett tag!",
  level_coupeDesAiguillesIntro: "Det är den stora kvällen. FIS inspekterar imorgon. Varje pist måste vara perfekt — visa mig vad du lärt dig.",
  marieWelcome: "Kom och värm dig Chez Marie. En god tartiflette!",
  marieIntro: "Hej! Jag är Marie, jag driver restaurangen uppe vid pisten. Kom förbi när du vill — en varm måltid gör underverk!",

  // Changelog
  changelog_20260219_date: "19 februari 2026",
  changelog_20260219: "🎬 Prolog för nya spelare\n📖 Förenklad handledning\n🌦️ Slumpmässigt menyväder\n🔗 Delbara dagliga åk\n🎥 Filmisk sluttext",
  changelog_20260222_date: "22 februari 2026",
  changelog_20260222: "🚩 Ombalansering av slalomportar\n💬 Feedbackknapp",
  changelog_20260223_date: "23 februari 2026",
  changelog_20260223: "📲 Installera på din enhet och spela offline",
  changelog_20260220_date: "20 februari 2026",
  changelog_20260220: "🗺️ Pistkartan\n🎿 Skidortsterminologi",
  changelog_20260217_date: "17 februari 2026",
  changelog_20260217: "🏔️ Sju pistformer\n🎯 Banvariation förbättrad\n⚡ Smidigare skidåkning",
  changelog_20260216_date: "16 februari 2026",
  changelog_20260216: "🎲 Dagens pister",
  changelog_20260215_date: "15 februari 2026",
  changelog_20260215: "⚡ Nattrendering uppdaterad\n📱 Touchknappar i skidläge\n⌨️ Tangentbordslayout-detektion",
  changelog_20260214_date: "14 februari 2026",
  changelog_20260214: "🎪 Tricks & kombos\n🏂 Fartställning & halfpipe-fysik\n👁️ Bättre pistkontrast\n📱 Auto-pistning vid vinsch (touch)\n♿ Högkontrastläge",
  changelog_20260213_date: "13 februari 2026",
  changelog_20260213: "🚩 Slalomportar\n🏔️ Skidhopp\n⚡ Förbättrad prestanda\n🎹 Nocturn pianomusik\n🔊 Motorvolym justerbar",
  changelog_20260212_date: "12 februari 2026",
  changelog_20260212: "📋 Pistkartan\n🔗 Brytbar vinschkabel\n🕹️ Kontrolldiagnostik\n🍽️ Maries rätter\n❄️ Köldexponering",
  changelog_20260211_date: "11 februari 2026",
changelog_20260211: "⛷️ Skidåkning efter preparering\n🎯 Prepareringskvalitet\n🏔️ Färgkodade branta zoner\n🏗️ Park och tricks",
  changelog_20260210_date: "10 februari 2026",
    changelog_20260210: "🎵 Musik och ljudeffekter\n🔈 Volyminställningar\n⏱️ Autokalibrerade pisttider\n⏭️ Hoppa över handledning\n🏔️ Lavinzoner omdesignade",
  changelog_20260209_date: "9 februari 2026",
  changelog_20260209: "🏔️ Alpina vinst/förlust-skärmar\n❄️ Snöansamling under storm\n🏆 Felfri bonus\n🔊 Väder- och djurljud",
  changelog_20260208_date: "8 februari 2026",
  changelog_20260208: "📊 Omdesignad instrumentpanel\n🏔️ Le Glacier och Coupe des Aiguilles\n🦅 Alpin fauna\n🎨 Karaktärsporträtt\n🎮 Tangentbords- och gamepad-navigering",
  changelog_20260207_date: "7 februari 2026",
  changelog_20260207: "🎨 Retrodesign\n🎯 Bonusmål\n🕹️ Ombindning av gamepad-knappar\n🎮 Gamepad-menynavigering",
  changelog_20260206_date: "6 februari 2026",
  changelog_20260206: "🛤️ Körbara servicevägar\n🕹️ Virtuell joystick\n🌍 5 kompletta språk",
  changelog_20260205_date: "5 februari 2026",
  changelog_20260205: "🏔️ Klippbranter\n🌙 Nattstrålkastare\n🔗 Vinschmekanik\n⌨️ Tangentbordsnavigering",
  changelog_20260204_date: "4 februari 2026",
  changelog_20260204: "🎮 Gamepad-stöd\n📱 Pekskärmskontroller\n💪 Uthållighet\n💾 Spara framsteg\n♿ Tillgänglighet",
  changelog_20260203_date: "3 februari 2026",
  changelog_20260203: "🚜 Lansering: 9 backar, skidskola\n❄️ Preparering, bränsle, laviner\n🏆 Tack och progression",
  // Key names
  key_space: "BLANKSTEG",
  key_shift: "SHIFT",
  key_ctrl: "CTRL",
  key_alt: "ALT",
  key_enter: "ENTER",
  key_tab: "TAB",
  key_esc: "ESC",
  key_del: "DEL",
  dailyRuns: "Dagens pister",
  dailyRuns_dailyShift: "Dagskift",
  dailyRuns_randomRun: "Slumpmässig körning",
  dailyRuns_rank: "Rankning",
  dailyRuns_seed: "Frö",
  // UNUSED   dailyRuns_start: "Starta kontrakt",
  dailyRuns_locked: "Slutför alla backar för att låsa upp",
  dailyRuns_lockedShared: "Klara alla backar för att låsa upp dagliga rundor och spela denna delade piste",
  // UNUSED   dailyRun_levelName: "Kontrakt",
  dailyRun_levelTask: "Preparera pisten till måltäckning",
  dailyRuns_briefing: "Uppdrag",
  dailyRuns_target: "Mål",
  dailyRuns_timeLimit: "Tid",
  dailyRuns_weather_clear: "Klart väder",
  dailyRuns_weather_light_snow: "Lätt snöfall",
  dailyRuns_weather_storm: "Stormförhållanden",
  dailyRuns_night: "Nattskift",
  dailyRuns_day: "Dagskift",
  rank_green: "Grön",
  rank_blue: "Blå",
  rank_red: "Röd",
  rank_black: "Svart",
  rank_park: "Park",
  share: "Dela",
  copied: "Länk kopierad!",
  playSharedSeed: "Delad runda",
  dailyRunBriefingJP: "Pisten måste vara klar innan liftarna öppnar. Sätt igång.",
  dailyRunBriefingThierry: "Var försiktig där uppe — branta partier och instabil snö. Håll dig skärpt.",
  dailyRunBriefingMarie: "Det blir en kall natt ikväll. Kom in på restaurangen och värm dig om du behöver.",
  dailyRunBriefingEmilie: "Ännu en pist. Försök slå min tid!"
};

export default sv;
